import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

/**
 * turns days into week/month/year
 */
@Pipe({ name: 'daysToWeekMonthYear' })
export class DaysToWeekMonthYearPipe implements PipeTransform {
  transform(value: number): string {
    if (value === 1) {
      return `1 jour`;
    }
    if (value < 30) {
      return `${value} jours`;
    }
    if (value < 365) {
      return Math.floor(value / 30) === 12 ? '1 an' : `${Math.floor(value / 30)} mois`;
    }
    if (value < 730) {
      return Math.floor((value % 365) / 30) ? `1 an et ${Math.floor((value % 365) / 30)} mois` : '1 an';
    }

    return Math.floor((value % 365) / 30)
      ? `${Math.floor(value / 365)} ans et ${Math.floor((value % 365) / 30)} mois`
      : `${Math.floor(value / 365)} ans`;
  }
}

@NgModule({
  declarations: [DaysToWeekMonthYearPipe],
  exports: [DaysToWeekMonthYearPipe],
  providers: [DaysToWeekMonthYearPipe],
  imports: [CommonModule],
})
export class DaysToWeekMonthYearModule {}
